import { useState, useCallback, useRef } from 'react';

export default function useModal() {
  const [modal, setModal] = useState({
    isOpen: false,
    type: 'success',
    title: '',
    message: '',
  });

  const resolverRef = useRef(null);

  const showSuccess = useCallback((title, message) => {
    setModal({ isOpen: true, type: 'success', title, message });
  }, []);

  const showError = useCallback((title, message) => {
    setModal({ isOpen: true, type: 'error', title, message });
  }, []);

  const showConfirm = useCallback((title, message) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setModal({ isOpen: true, type: 'confirm', title, message });
    });
  }, []);

  const close = useCallback(() => {
    setModal((p) => ({ ...p, isOpen: false }));
  }, []);

  const handleAccept = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(true);
      resolverRef.current = null;
    }
    close();
  }, [close]);

  const handleCancel = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(false);
      resolverRef.current = null;
    }
    close();
  }, [close]);

  const modalProps = {
    isOpen: modal.isOpen,
    type: modal.type,
    title: modal.title,
    message: modal.message,
    onClose: close,
    onAccept: handleAccept,
    onCancel: handleCancel,
  };

  return { showSuccess, showError, showConfirm, modalProps };
}
